import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';

function BarChart({ x, y, yLabel }) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        const data = {
            labels: x,
            datasets: [
                {
                    label: yLabel,
                    data: y,
                    borderWidth: 1,
                }
            ]
        };
        const options = {
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        title: (tooltipItems) => {
                            return tooltipItems[0].label;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: 'black',
                        callback: function (value, index, values) {
                            return `${this.getLabelForValue(value).substring(0, 5)}...`;
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: 'black',
                    },
                    grid: {
                        drawBorder: false
                    }
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, [x, y, yLabel]);

    return (
        <Chart type="bar" data={chartData} options={chartOptions} height='300px' width='600px'/>
    )
}

export default BarChart;
